import { window } from "global";
import React, { useState, useEffect } from "react";
// import { usePermissions } from "hooks/general-hooks";
import { SEND_PAGE_COUNT } from "components/GoogleAnalyticsWrapper";

let LOADED = {};

const AdComponent = (props) => {
  // const [permissions] = usePermissions();
  // const [ad, setAd] = useState(null);
  const {
    slotId,
    // shouldChangeForRoute = () => {},
    // backupAd
  } = props;

  let [firstLoaded, setFirstLoaded] = useState(true);

  useEffect(() => {
    // only call egAps.render on first website page load
    // console.log("SEND_PAGE_COUNT", SEND_PAGE_COUNT, firstLoaded);
    if (firstLoaded && SEND_PAGE_COUNT === 1) {
      // console.log("RENDER", slotId);
      if (window && window.egAps && typeof window.egAps.render === "function") {
        egAps.render([slotId]);
      }
      setFirstLoaded(false);
    }
  }, []);

  return <div id={slotId}></div>;
};

export default AdComponent;
